export default "__VITE_ASSET__BjthbQwu__"